import { useEffect, useRef, useState } from 'react';
import {
  DropdownProps,
  OrderSelectionOptionItem,
} from '../interface/interface';
import { DropdownIcon } from '../assets/svgImages';

const Dropdown = ({
  defaultText,
  options,
  defaultSelected,
  onSelect,
}: DropdownProps) => {
  const [selectedOption] = useState<OrderSelectionOptionItem>(defaultSelected);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const handleOptionClick = (option: OrderSelectionOptionItem) => {
    onSelect(option.id);
    setIsOpen(false);
  };

  const handleOutsideClick = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <div>
        <span className="rounded-md shadow-sm">
          <button
            type="button"
            className="inline-flex justify-center items-center w-full rounded-md bg-secondary-cornflowerblue-600 
            p-3 2.5xl:px-6 2.5xl:py-3 text-sm 2.5xl:text-base font-semibold text-white"
            onClick={() => setIsOpen(!isOpen)}
          >
            {defaultText}
            <DropdownIcon />
          </button>
        </span>
      </div>

      {isOpen && (
        <div className="origin-top-right absolute right-0 mt-2 w-max rounded-md shadow-lg bg-white">
          <div
            className="py-1"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            {options.map((option, index) => (
              <button
                key={index}
                onClick={() => handleOptionClick(option)}
                className={`block w-full text-left px-4 py-2 text-sm ${
                  selectedOption.name === option.name
                    ? 'text-secondary-green-500'
                    : 'text-primary-blue-500 hover:bg-secondary-cornflowerblue-600 hover:text-white'
                }`}
                role="menuitem"
              >
                {option.name}{' '}
                {selectedOption.name === option.name && <span>&#10003;</span>}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
export default Dropdown;
